import { getGlobalConfig } from '@adornis/bh-matching-config/entities/global-config.js';
import '@adornis/buchungsheld-theme/components/tr-loader.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/tiptap/client/x-tiptap.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

/*
 * @element buddy-page-imprint
 */
@customElement('buddy-page-imprint')
export class BuddyPageImprint extends ChemistryLitElement {
  @state() private readonly _config = new RXController(this, getGlobalConfig()({ imprint: 1 }));

  override render() {
    if (this._config.isLoading)
      return html` <x-flex h100 w100 center crossaxis-center> <tr-loader></tr-loader> </x-flex> `;
    return html`
      <x-flex h100 w100 crossaxis-center space="lg">
        <x-flex w100 ${css({ maxWidth: this.sizes.maxReadableWidth })}>
          <x-tiptap plain disabled .value=${this._config.value?.imprint}></x-tiptap>
        </x-flex>
      </x-flex>
    `;
  }

  override styles() {
    return [...super.styles(), { ':host': { overflowY: 'auto' } }];
  }
}
